export const columns = [
  {
    field: 'status',
    headerName: 'Durum',
    width: 125,
    renderCell: (data) => {
      return (
        <span>
          {data?.row?.status === 'SUCCESSFUL' ? 'BAŞARILI' : 'BAŞARISIZ'}
        </span>
      );
    },
  },
  {
    field: 'card.id',
    headerName: 'Kart Numarası',
    width: 150,
    renderCell: (data) => {
      return <span>{data?.row?.identification}</span>;
    },
  },
  {
    field: 'employee.id',
    headerName: 'Personel',
    width: 250,
    renderCell: (data) => {
      return (
        <span>
          {data?.row?.employee?.id} {data?.row?.employee?.user?.firstname}{' '}
          {data?.row?.employee?.user?.lastname}
        </span>
      );
    },
  },
  {
    field: 'coordinate',
    headerName: 'Koordinat',
    width: 200,
    renderCell: (data) => {
      return <span>{data?.row?.coordinate}</span>;
    },
  },
  {
    field: 'time',
    headerName: 'Tarih',
    width: 150,
    notFilter: true,
    renderCell: (e) => (
      <div>{e.value ? new Date(e.value).toLocaleString('tr') : ''}</div>
    ),
  },
];
